/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React, { createContext, useState, useContext, useEffect } from 'react'
import dayjs from 'dayjs'
import useLocalStorage from '../hook/useLocalStorage'
import { DashboardContext } from './DashboardProvider.js'
import {
    getTimelinePeriod,
    getDateTimeRangeToEnd,
    defaultLayouts,
} from '../functionTool/functionTool.js'

export const AnalysisContext = createContext()

// 每次新增面板時遞增此版本號
const LAYOUT_VERSION = 2

export default function AnalysisProvider({ children }) {
    const [date, setDate] = useState(dayjs())
    const [dateline, setDateline] = useState('day')
    const [timezone, setTimezone] = useState('8')
    const [tempLayouts, setTempLayouts] = useState({})
    const { listID, setListID } = useContext(DashboardContext)
    const [layouts, setLayouts] = useLocalStorage('layouts', defaultLayouts)
    const [analysisMenu, setAnalysisMenu] = useLocalStorage('analysisMenu', [])
    const [layoutVersion, setLayoutVersion] = useLocalStorage('layoutVersion', 0)

    // 補齊使用者舊版 layout 中缺少的新面板
    useEffect(() => {
        if (layoutVersion >= LAYOUT_VERSION) return

        const existingKeys = new Set((layouts?.lg || []).map((item) => item.i))
        const menuKeys = new Set((analysisMenu || []).map((item) => item.key))
        const newPanels = defaultLayouts.lg.filter(
            (item) => !existingKeys.has(item.i) && !menuKeys.has(item.i)
        )

        if (newPanels.length > 0) {
            setLayouts((prev) => ({
                ...prev,
                lg: [...(prev?.lg || []), ...newPanels],
            }))
        }

        setLayoutVersion(LAYOUT_VERSION)
    }, []) // eslint-disable-line
    const [dragNum, setDragNum] = useState()
    const [isDraggable, setIsDraggable] = useState(false)
    const [mounted, setMounted] = useState(false)
    const timescale = getTimelinePeriod(dateline)
    const { startDatetime, endDatetime } = getDateTimeRangeToEnd(dateline, date) //日、週、月、年開始時間、結束時間

    const [offset, setOffset] = useState({
        refAreaLeft: '',
        refAreaRight: '',
        left: Date.parse(startDatetime),
        right: Date.parse(endDatetime),
    })
    const [section, setSection] = useState({
        left: 0,
        right: 0,
        fetch: false,
    })

    const querys = {
        date,
        setDate,
        listID,
        setListID,
        dateline,
        setDateline,
        startDatetime,
        endDatetime,
        timezone,
        setTimezone,
        timescale,
        offset,
        setOffset,
        section,
        setSection,
        isDraggable,
        setIsDraggable,
        layouts,
        setLayouts,
        analysisMenu,
        setAnalysisMenu,
        dragNum,
        setDragNum,
        tempLayouts,
        setTempLayouts,
        mounted,
        setMounted,
    }
    // console.log(querys)
    return (
        <AnalysisContext.Provider value={querys}>
            {children}
        </AnalysisContext.Provider>
    )
}
